{
  "organization": {
    "enabled": "Aktiv",
    "disabled": "Inaktiv",
    "enable": "Aktivieren",
    "disable": "Deaktivieren",
    "name": "Name",
    "code": "Code",
    "done": "done",
    "cancel": "Abbruch",
    "add": "Anlegen",
    "create": "Create {{name}}",
    "edit": "Ändern",
    "save": "Speichern {{name}}",
    "delete": "Löschen",
    "assign": "Manage",
    "active": "Aktiv",
    "status": "Status",
    "details": "Details",
    "messages": {
      "emptyList": "The list is empty"
    },
    "userRoles": {
      "b2bcustomergroup": "Customer",
      "b2bapprovergroup": "Approver",
      "b2bmanagergroup": "Manager",
      "b2badmingroup": "Admin",
      "show_order_history": "Show Order History Permission",
      "edit_order_history": "Edit Order History Permission",
      "show_delivery_notes": "Show Delivery Notes Permission",
      "show_invoices_overview": "Show Invoices Overview Permission",
      "show_stock_protection": "Show Stock Protection Permission",
      "show_statistics": "Show Statistics Permission",
      "edit_own_vk": "Edit Own Vk Permission",
      "show_forum": "Show Forum Permission",
      "rio_cart_show": "Only Show Rio Cart Permission",
      "rio_cart_create_update": "Create And Update Cart Permission",
      "rio_cart_order": "Place Cart Order Permission",
      "show_branches": "Show Branches Permission",
      "standard_user": "Ringfoto Standard User",
      "admin_user": "Ringfoto Admin User",
      "shopview_user": "Ringfoto Shop View User",
      "show_bestprice": "Show Bestprice Permission"
    },
    "changePassword": {
      "title": "Kennwort ändern",
      "subtitle": "Benutzer: ",
      "passwordSpecs": "<p>Bitte beachten Sie, dass das neue Passwort folgende Anforderungen erf&uuml;llen muss:</p><ul><li>Minimum 8 Zeichen</li><li>darin mindestens ein Gro&szlig;buchstabe</li><li>und mindestens eine Zahl</li><li>und mindestens eins der folgenden Sonderzeichen   !@#$%^*()_-+{};:.,</li></ul>"
    },
    "breadcrumb": "Verwaltung",
    "notification": {
      "noSufficientPermissions": "Sie haben keine ausreichenden Berechtigungen, um auf die Seite zuzugreifen.",
      "notExist": "This item does not exist",
      "disabled": "You cannot edit a disabled item"
    },
    "confirmation": {
      "cancel": "ABBRUCH",
      "confirm": "OK",
      "disable": "DEAKTIVIEREN",
      "delete": "LÖSCHEN"
    },
    "httpHandlers": {
      "conflict": {
        "budget": "Budget with code {{ code }} already exists.",
        "costCenter": "Cost center with code {{ code }} already exists.",
        "unit": "Organizational unit with uid {{ code }} already exists.",
        "user": "Benutzer {{ code }} bereits vorhanden",
        "userGroup": "User Group with id {{ code }} already exists",
        "permission": "Approval Permission with code {{ code }} already exists.",
        "unknown": "Server validation error."
      }
    }
  }
}
